import * as React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  FormLabel,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { VENDOR_REGISTRATION_STEP_1 } from "../../utils/Validation";
import { handleKeyPress } from "../../common/Events";
import { useNavigate } from "react-router-dom";
import verifyVendorService from "../../services/verifyVendorService";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";

const FirstStep = ({ onClickNext, formData, setFormData }) => {
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const { showNotification, enableNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const formOption = {
    resolver: yupResolver(VENDOR_REGISTRATION_STEP_1),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOption);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      enableNotification();
      const vendorResponse = await verifyVendorService(baseUrl, data);

      if (vendorResponse?.messageCode === 6) {
        const responseObj = {
          vendorName: vendorResponse?.vendorName,
        };
        setFormData({ ...formData, ...data, ...responseObj });
        onClickNext();
      } else {
        showNotification(
          "Error",
          vendorResponse?.message ?? "Failed to Verify Vendor"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to Verify Vendor");
    } finally {
      setLoading(false);
    }
  };
  const goBack = () => {
    navigate("/login");
  };

  return (
    <>
      <Grid className="bg-white">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 4 }}>
            <Box>
              <form>
                <Grid
                  container
                  spacing={1}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    display="flex"
                    justifyContent="center"
                  >
                    <FormLabel
                      className="stepperFormLabel"
                      required={true}
                      sx={{ width: "150px" }}
                    >
                      Vendor Code
                    </FormLabel>
                    <TextField
                      name="vendorCode"
                      fullWidth
                      className="stepperFormInput"
                      size="small"
                      onKeyDown={handleKeyPress}
                      required
                      autoComplete="off"
                      {...register("vendorCode", { required: true })}
                      error={Boolean(errors?.vendorCode)}
                      helperText={errors?.vendorCode?.message}
                    />
                  </Grid>

                  <Grid item xs={126} sm={12}>
                    <FormLabel
                      className="stepperFormLabel"
                      required={true}
                      sx={{ width: "150px" }}
                    >
                      GSTIN
                    </FormLabel>
                    <TextField
                      className="stepperFormInput"
                      name="gstin"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      {...register("gstin", { required: true })}
                      error={Boolean(errors?.gstin)}
                      helperText={errors?.gstin?.message}
                    />
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
          <Divider />
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
              <Button
                variant="outlined"
                onClick={goBack}
                sx={{ mr: 1 }}
                color="error"
              >
                Cancel
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                variant="outlined"
              >
                Next
              </Button>
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>
    </>
  );
};

export default FirstStep;
